(() => {
  const header = document.querySelector('[data-header]');
  const drawer = document.getElementById('menu-drawer');
  const menuButton = document.querySelector('[data-menu-open]');
  const closeMenu = () => { drawer?.close(); menuButton?.setAttribute('aria-expanded', 'false'); document.body.classList.remove('menu-open'); menuButton?.focus(); };
  menuButton?.addEventListener('click', () => { drawer.showModal(); menuButton.setAttribute('aria-expanded', 'true'); document.body.classList.add('menu-open'); });
  document.querySelector('[data-menu-close]')?.addEventListener('click', closeMenu);
  drawer?.addEventListener('cancel', closeMenu);
  drawer?.addEventListener('click', (event) => { if (event.target === drawer && event.clientX > drawer.getBoundingClientRect().right) closeMenu(); });
  const informationDialogs = new Map(Array.from(document.querySelectorAll('[data-info-dialog]'), dialog => [dialog.id, dialog]));
  let informationTrigger;
  const closeInformation = dialog => {
    dialog.close();
    document.body.classList.remove('info-open');
    if (window.location.hash === '#' + dialog.id) {
      const url = new URL(window.location.href);
      url.hash = '';
      history.replaceState({}, '', url);
    }
    informationTrigger?.focus();
  };
  const openInformation = (dialog, trigger) => {
    if (drawer?.open) {
      closeMenu();
      informationTrigger = menuButton;
    } else informationTrigger = trigger;
    for (const other of informationDialogs.values()) if (other.open && other !== dialog) other.close();
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('info-open');
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#"]');
    const dialog = link && informationDialogs.get(link.getAttribute('href').slice(1));
    if (!dialog) return;
    event.preventDefault();
    openInformation(dialog, link);
    const url = new URL(window.location.href);
    url.hash = dialog.id;
    history.replaceState({}, '', url);
  });
  for (const dialog of informationDialogs.values()) {
    dialog.querySelector('[data-info-close]')?.addEventListener('click', () => closeInformation(dialog));
    dialog.addEventListener('cancel', event => { event.preventDefault(); closeInformation(dialog); });
    dialog.addEventListener('click', event => {
      const bounds = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) closeInformation(dialog);
    });
  }
  const hashInformation = informationDialogs.get(window.location.hash.slice(1));
  if (hashInformation) openInformation(hashInformation);
  const slideshowInstances = new WeakSet();
  const initSlideshow = root => {
    root.querySelectorAll('[data-slideshow]').forEach(carousel => {
      if (slideshowInstances.has(carousel)) return;
      slideshowInstances.add(carousel);
      const slides = Array.from(carousel.querySelectorAll('[data-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-slide-to]'));
      const controls = carousel.querySelector('[data-slide-controls]');
      const pauseButton = carousel.querySelector('[data-slide-pause]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let active = 0, timer, paused = reducedMotion.matches;
      const show = index => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== active; });
        dots.forEach((dot, i) => { if (i === active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      };
      const stop = () => { clearInterval(timer); timer = undefined; };
      const start = () => {
        stop();
        if (paused || document.hidden || carousel.matches(':hover') || carousel.contains(document.activeElement)) return;
        timer = setInterval(() => { if (!carousel.isConnected) stop(); else show(active + 1); }, 7000);
      };
      const setPauseLabel = () => {
        pauseButton.setAttribute('aria-pressed', String(paused));
        pauseButton.setAttribute('aria-label', paused ? 'Pornește schimbarea automată' : 'Oprește schimbarea automată');
        pauseButton.querySelector('[data-pause-symbol]').textContent = paused ? '▷' : 'Ⅱ';
      };
      dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
      pauseButton.addEventListener('click', () => { paused = !paused; setPauseLabel(); start(); });
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', () => setTimeout(start, 0));
      carousel.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault(); show(active + (event.key === 'ArrowLeft' ? -1 : 1)); dots[active].focus();
      });
      document.addEventListener('visibilitychange', start);
      reducedMotion.addEventListener('change', event => { if (event.matches) { paused = true; setPauseLabel(); stop(); } });
      controls.hidden = false; show(0); setPauseLabel(); start();
    });
  };
  const favoritesDialog = document.getElementById('favorites-dialog');
  const favoritesButton = document.querySelector('[data-favorites-open]');
  const favoritesKey = 'resenss-favorites-ro';
  const safeProduct = item => {
    try {
      const url = new URL(item.url, location.origin);
      const image = item.image ? new URL(item.image, location.origin) : undefined;
      return typeof item.handle === 'string' && typeof item.title === 'string' && url.origin === location.origin && url.pathname.includes('/products/') && (!image || image.protocol === 'https:');
    } catch { return false; }
  };
  let favorites = [];
  try { const stored = JSON.parse(localStorage.getItem(favoritesKey) || '[]'); if (Array.isArray(stored)) favorites = stored.filter(safeProduct).slice(0,100); } catch {}
  const syncFavorites = () => {
    document.querySelectorAll('[data-favorite]').forEach(button => {
      const saved = favorites.some(item => item.handle === button.dataset.favorite);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', (saved ? 'Elimină ' : 'Salvează ') + button.dataset.productTitle + (saved ? ' din favorite' : ' în favorite'));
    });
    const count = document.querySelector('[data-favorites-count]');
    if (count) { count.textContent = String(favorites.length); count.hidden = favorites.length === 0; }
    if (favoritesButton) favoritesButton.hidden = false;
    const list = favoritesDialog?.querySelector('[data-favorites-list]');
    if (!list) return;
    list.replaceChildren();
    favoritesDialog.querySelector('[data-favorites-empty]').hidden = favorites.length > 0;
    favorites.forEach(item => {
      const row = document.createElement('article'); row.className = 'favorite-row';
      const imageLink = document.createElement('a'); imageLink.href = item.url; imageLink.setAttribute('aria-label', item.title);
      if (item.image) { const image = document.createElement('img'); image.src = item.image; image.alt = item.title; image.width = 100; image.height = 100; image.loading = 'lazy'; imageLink.append(image); }
      const content = document.createElement('div');
      const title = document.createElement('p'); title.textContent = item.title;
      const link = document.createElement('a'); link.href = item.url; link.textContent = 'Vezi produsul'; link.className = 'text-link';
      content.append(title, link);
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'favorite-remove'; remove.textContent = 'Elimină'; remove.setAttribute('aria-label','Elimină '+item.title+' din favorite');
      remove.addEventListener('click', () => { favorites = favorites.filter(favorite => favorite.handle !== item.handle); saveFavorites(); favoritesDialog.querySelector('.favorite-remove')?.focus(); });
      row.append(imageLink, content, remove); list.append(row);
    });
  };
  const saveFavorites = () => { try { localStorage.setItem(favoritesKey, JSON.stringify(favorites)); } catch {} syncFavorites(); };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-favorite]');
    if (!button) return;
    const handle = button.dataset.favorite;
    if (favorites.some(item => item.handle === handle)) favorites = favorites.filter(item => item.handle !== handle);
    else {
      const item = {handle, title:button.dataset.productTitle, url:button.dataset.productUrl, image:button.dataset.productImage};
      if (safeProduct(item) && favorites.length < 100) favorites.push(item);
    }
    saveFavorites();
  });
  const closeFavorites = () => { favoritesDialog?.close(); document.body.classList.remove('favorites-open-body'); favoritesButton?.focus(); };
  favoritesButton?.addEventListener('click', () => { syncFavorites(); favoritesDialog.showModal(); document.body.classList.add('favorites-open-body'); });
  favoritesDialog?.querySelector('[data-favorites-close]')?.addEventListener('click', closeFavorites);
  favoritesDialog?.addEventListener('cancel', event => { event.preventDefault(); closeFavorites(); });
  favoritesDialog?.addEventListener('click', event => {
    const rect = favoritesDialog.getBoundingClientRect();
    if (event.target === favoritesDialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) closeFavorites();
  });
  window.addEventListener('storage', event => {
    if (event.key !== favoritesKey) return;
    try { const stored = JSON.parse(event.newValue || '[]'); favorites = Array.isArray(stored) ? stored.filter(safeProduct).slice(0,100) : []; syncFavorites(); } catch {}
  });
  initSlideshow(document); syncFavorites();
  document.addEventListener('shopify:section:load', event => { initSlideshow(event.target); syncFavorites(); });
  const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 40);
  updateHeader(); window.addEventListener('scroll', updateHeader, { passive: true });
  document.querySelector('[data-sort]')?.addEventListener('change', event => event.target.form.submit());
  const variantSelect = document.querySelector('[data-variant-select]');
  const json = document.querySelector('[data-product-json]');
  if (variantSelect && json) {
    const product = JSON.parse(json.textContent);
    variantSelect.addEventListener('change', () => {
      const variant = product.variants.find(item => String(item.id) === variantSelect.value);
      if (!variant) return;
      document.querySelector('[data-product-price]').textContent = new Intl.NumberFormat('ro-RO', { style: 'currency', currency: window.resenssCurrency || 'RON', currencyDisplay: 'narrowSymbol', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(variant.price / 100);
      const compare = document.querySelector('[data-compare-price]');
      if (compare) { compare.hidden = !(variant.compare_at_price > variant.price); compare.textContent = variant.compare_at_price > variant.price ? new Intl.NumberFormat('ro-RO', { style: 'currency', currency: window.resenssCurrency || 'RON', currencyDisplay: 'narrowSymbol', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(variant.compare_at_price / 100) : ''; }
      document.querySelector('[data-sku]').textContent = variant.sku ? 'Cod produs: ' + variant.sku : '';
      const button = document.querySelector('[data-add-to-cart]'); button.disabled = !variant.available; button.textContent = variant.available ? 'Adaugă în coș' : 'Stoc epuizat';
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
    });
  }
})();
